import uiCore = require("../core/uicore");
import reportsCommon = require("./reportscommon");
import reports = require("./reports");

export class ReportsInstaller extends uiCore.BaseInstaller {

    constructor() {

        var pages = [
            reports.Reports,
            reportsCommon.PersonTimeBalanceReport,
            reportsCommon.PersonCVReport,
            reportsCommon.PersonContactInfoReport,
            reportsCommon.PersonNextOfKinReport,
            reportsCommon.PersonCompetencesReport,
            reportsCommon.PersonCompetenceListReport,
            reportsCommon.WorkplaceTimeBalanceReport,
            reportsCommon.WorkplaceRequirementsReport,
            reportsCommon.WorkplaceValidationReport,
            reportsCommon.WorkplaceScheduleReport,
            reportsCommon.WorkplaceScheduleTimetableReport
        ];
        var controls = [];
        super(pages, controls, []);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/reports/reports.installer.ts